import Icon from './Icons'
import { LINE_DASHES, CITY_SHAPES } from '../utils/overlayStyles'

const DASH_LABELS = { solid: '── plein', dash: '╌ tirets', dot: '⋯ points' }
const SHAPE_LABELS = { circle: '●', square: '■', triangle: '▲', star: '★' }

// Color + width (+ optional dash / shape) editor for the line/point overlays
// (world roads/railways/cities and RP infrastructure). Shared by the sidebar
// and the display-settings panel.
export default function OverlayStyleEditor({ color, width, widthLabel = 'Épaisseur', onColor, onWidth, onReset, dash, onDash, shape, onShape }) {
  return (
    <div className="overlay-style-editor">
      <div className="overlay-style-row">
        <input type="color" className="color-picker" value={color} onChange={(e) => onColor(e.target.value)} />
        <span className="color-value">{color}</span>
        <button className="overlay-style-reset" onClick={onReset} title="Réinitialiser">
          <Icon name="undo" size={13} />
        </button>
      </div>
      <div className="overlay-style-width">
        <span className="overlay-style-width-label">{widthLabel}</span>
        <input
          type="range" min="0.25" max="4" step="0.25"
          value={width}
          onChange={(e) => onWidth(parseFloat(e.target.value))}
        />
        <span className="range-value">×{width}</span>
      </div>
      {onDash && (
        <div className="overlay-style-options">
          {LINE_DASHES.map((d) => (
            <button
              key={d}
              className={`overlay-style-option ${(dash || 'solid') === d ? 'active' : ''}`}
              onClick={() => onDash(d)}
            >{DASH_LABELS[d]}</button>
          ))}
        </div>
      )}
      {onShape && (
        <div className="overlay-style-options">
          {CITY_SHAPES.map((s) => (
            <button
              key={s}
              className={`overlay-style-option shape ${(shape || 'circle') === s ? 'active' : ''}`}
              onClick={() => onShape(s)}
              title={s}
            >{SHAPE_LABELS[s]}</button>
          ))}
        </div>
      )}
    </div>
  )
}
